var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { sm12: "", md12: "" } },
    [
      _c("h2", { staticClass: "h2_title mb-1" }, [
        _vm._v("Información de Nota de Venta")
      ]),
      _c("v-divider"),
      _c(
        "v-flex",
        {
          attrs: {
            xs12: "",
            sm12: "",
            md12: "",
            "mt-5": "",
            layout: "",
            wrap: ""
          }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Nombre NDV", readonly: "" },
                model: {
                  value: _vm.data["Nombre NDV"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Nombre NDV", $$v)
                  },
                  expression: "data['Nombre NDV']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Cliente", readonly: "" },
                model: {
                  value: _vm.data["Cliente"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Cliente", $$v)
                  },
                  expression: "data['Cliente']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Fecha de Creación", readonly: "" },
                model: {
                  value: _vm.data["Fecha de Creación"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Fecha de Creación", $$v)
                  },
                  expression: "data['Fecha de Creación']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Divisa", readonly: "" },
                model: {
                  value: _vm.data["Divisa"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Divisa", $$v)
                  },
                  expression: "data['Divisa']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Lista de Precios", readonly: "" },
                model: {
                  value: _vm.data["Lista de Precios"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Lista de Precios", $$v)
                  },
                  expression: "data['Lista de Precios']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Modalidad", readonly: "" },
                model: {
                  value: _vm.data["Modalidad"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Modalidad", $$v)
                  },
                  expression: "data['Modalidad']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Tipo de Venta", readonly: "" },
                model: {
                  value: _vm.data["Tipo de Venta"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Tipo de Venta", $$v)
                  },
                  expression: "data['Tipo de Venta']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Mandante", readonly: "" },
                model: {
                  value: _vm.data["Mandante"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Mandante", $$v)
                  },
                  expression: "data['Mandante']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Flota", readonly: "" },
                model: {
                  value: _vm.data["Flota"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Flota", $$v)
                  },
                  expression: "data['Flota']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Tipo de Flota", readonly: "" },
                model: {
                  value: _vm.data["Tipo de Flota"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Tipo de Flota", $$v)
                  },
                  expression: "data['Tipo de Flota']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Area Respondable", readonly: "" },
                model: {
                  value: _vm.data["Area Respondable"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Area Respondable", $$v)
                  },
                  expression: "data['Area Respondable']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Ejecutivo de Venta", readonly: "" },
                model: {
                  value: _vm.data["Ejecutivo de Venta"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Ejecutivo de Venta", $$v)
                  },
                  expression: "data['Ejecutivo de Venta']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Cantidad de Equipos", readonly: "" },
                model: {
                  value: _vm.data["Cantidad de Equipos"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Cantidad de Equipos", $$v)
                  },
                  expression: "data['Cantidad de Equipos']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Precio Importe Total", readonly: "" },
                model: {
                  value: _vm.data["Precio Importe Total"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Precio Importe Total", $$v)
                  },
                  expression: "data['Precio Importe Total']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "CRM Estado", readonly: "" },
                model: {
                  value: _vm.data["CRM Estado"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "CRM Estado", $$v)
                  },
                  expression: "data['CRM Estado']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "CRM Razon del Estado", readonly: "" },
                model: {
                  value: _vm.data["CRM Razon del Estado"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "CRM Razon del Estado", $$v)
                  },
                  expression: "data['CRM Razon del Estado']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Estado en Conecta", readonly: "" },
                model: {
                  value: _vm.data["Estado en Conecta"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Estado en Conecta", $$v)
                  },
                  expression: "data['Estado en Conecta']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Fecha Creación CRM", readonly: "" },
                model: {
                  value: _vm.data["Fecha Creacion CRM"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Fecha Creacion CRM", $$v)
                  },
                  expression: "data['Fecha Creacion CRM']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-textarea", {
                attrs: { label: "Observación", readonly: "" },
                model: {
                  value: _vm.data["Observaciones"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Observaciones", $$v)
                  },
                  expression: "data['Observaciones']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-textarea", {
                attrs: { label: "Descripción", readonly: "" },
                model: {
                  value: _vm.data["Descripcion"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Descripcion", $$v)
                  },
                  expression: "data['Descripcion']"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }